import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'
import axios from 'axios'

export default class KlaviyoBackInStock extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this._countries = this._elem.querySelectorAll('[data-klaviyo-country]')
    this._email = this._elem.querySelector('[data-klaviyo-email]')
    this._location = this._elem.querySelector('[data-klaviyo-location]')
    this._selectedLocation = this._elem.querySelector('[data-klaviyo-selected-location]')
    this._success = this._elem.querySelector('[data-klaviyo-success]')
    this._error = this._elem.querySelector('[data-klaviyo-error]')
    this._variantId = this._elem.querySelector('[data-klaviyo-variant]')
    this._checkbox = this._elem.querySelector('[data-klaviyo-subscribe-checkbox]')
    this._button = this._elem.querySelector('[type="submit"]')
  }

  async mount () {

    for(let country of this._countries) {
        country.addEventListener('click', async e => {
            e.preventDefault()
            let selected = country.dataset.value
            this._selectedLocation.innerHTML = country.innerHTML
            this._location.value = selected
        })
    }

    this._elem.addEventListener('submit', async e => {
      e.preventDefault()

      this._success.classList.add('hide')
      this._error.classList.add('hide')

      let valid = this._elem.reportValidity()

      if (valid) {

        this._elem.setAttribute('disabled', 'disabled')

        let promises = []

        
        if(this._checkbox.checked) {
            const options = {
                method: 'POST',
                headers: {revision: '2024-07-15', 'content-type': 'application/json'},
                body: JSON.stringify({
                  data: {
                    type: 'subscription',
                    attributes: {
                      profile: {
                        data: {
                          type: 'profile',
                          attributes: {
                            email: this._email.value,
                            properties: { 
                                'Location (ZPD)': this._location.value
                            }
                          }
                        }
                      }
                    },
                    relationships: {list: {data: {type: 'list', id: this._options.listId }}}
                  }
                })
              };
              
              promises.push(fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this._options.accountId}`, options))
        } else {
                const options = {
                    method: 'POST',
                    headers: {
                        accept: 'application/json',
                        revision: '2024-07-15',
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                      data: {
                        type: 'profile',
                        attributes: {
                            email: this._email.value,
                            properties: { 
                                'Location (ZPD)': this._location.value
                            }
                        }
                      }
                    })
                  };
                  
                  promises.push(fetch(`https://a.klaviyo.com/client/profiles/?company_id=${this._options.accountId}`, options))
        }

        let variantId = `$shopify:::$default:::${this._variantId.value}`
        
        const bisOptions = {
            method: 'POST',
            headers: {
                accept: 'application/json',
                revision: '2024-07-15',
                'content-type': 'application/json'
            },

            body: JSON.stringify({
                data: {
                    type: 'back-in-stock-subscription',
                    attributes: {
                        profile: {data: {type: 'profile', attributes: {email: this._email.value }}},
                        channels: ['EMAIL']
                    },
                    relationships: {
                        variant: {data: {type: 'catalog-variant', id: variantId }}
                    }
                }
            })
        }

        promises.push(fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this._options.accountId}`, bisOptions))

        Promise.all(promises).then(([res1, res2]) => {
           this._elem.reset()
           this._elem.classList.add('submitted')
           this._success.classList.remove('hide')

           this._elem.removeAttribute('disabled')

           setTimeout(() => {
            this._elem.classList.remove('submitted')
            this._success.classList.add('hide')
           }, 4000)
        }).catch((err) => {
            console.log(err);
        });

        }
    })
  }
}